// state.js

export default {
    companyList: [],
    currentCompany: {
        name: 'All Companies',
        value: 0,
    },
};
